

const createAccountReducer =(state ={}, action)=>{
    
    switch(action.type){
        case "CREATE_ACCOUNT_SUCCESS":
            return Object.assign({}, state, {
                CreateAccountapi: action.data,
            });
        case "VERIFY_EMAIL_SUCCESS":
            console.log(action.data);
            return Object.assign({}, state, {
                verifyEmail: action.data,
            });
        case "OTP_RESEND_SUCCESS":
                return Object.assign({}, state, {
                    ResendOtp: action.data,
                });
        case "REGISTER_KEYCLOAK_SUCCESS":
                 console.log(action.data);
                    return Object.assign({}, state, {
                        RegisterKeycloak: action.data,
                    });
        default:
            return state
    }
}
export default createAccountReducer;